import axios from 'axios'
import { getStoredToken } from '@/lib/api/session-refresh'

/**
 * Confirmação de senha para ações de dinheiro (step-up).
 *
 * O interceptor HTTP não pode desenhar tela, e o modal não pode ficar pendurado
 * em cada chamada de API. O componente global registra aqui como pedir a senha;
 * o interceptor só chama `requestStepUp()` quando o backend responde
 * `STEP_UP_REQUIRED`, e repete a requisição se o usuário confirmar.
 */
type StepUpHandler = () => Promise<boolean>

let handler: StepUpHandler | null = null

export const registerStepUpHandler = (fn: StepUpHandler | null) => {
    handler = fn
}

/** Devolve `true` quando o usuário confirmou a senha e a ação pode seguir. */
export const requestStepUp = async (): Promise<boolean> => {
    if (!handler) return false

    return handler()
}

/**
 * Envia a senha. Senha errada volta como exceção, para o modal mostrar a
 * mensagem do backend em vez de fechar como se tivesse dado certo.
 */
export const confirmStepUp = async (password: string): Promise<void> => {
    const baseURL = import.meta.env.VITE_API_BASE_URL

    await axios.post(
        `${baseURL}/auth/step-up`,
        { password },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getStoredToken() || ''}`,
            },
            withCredentials: true,
        }
    )
}
